import Button from '@mui/material/Button'

export default function StyledButton(props) {

    const styles = {
        // textTransform: 'inherit',
        px: 5,
        py: 1,
        fontWeight: 'bold',
        borderRadius: 4,
        background: `linear-gradient(to right, #3da1ef, #667eea)`,
        '&.Mui-disabled': {
            background: '#eaeaea',
            color: '#b3b3b3'
        }
    };

    return (
        <Button
            {...props}
            variant={props.variant || 'contained'}
            color={props.color || 'primary'}
            sx={styles}
        >
            {props.children}
        </Button>
    )

};

